/**
 * This file contains const valuesfor z-index 
 * css values to be used thoughtout.
 * 
 * This allows a centeral location for z-index
 * to be managed.
 */

export const overlayZIndex = 1000;
export const zindexSearchDropdown = overlayZIndex + 10;
export const zindexModal = zindexSearchDropdown + 1;
export const menuZIndex = overlayZIndex + 5;

export const productCardBadge = 10;
export const productCardVariants = productCardBadge + 1;

export const zindexAddToCartConfirmation = zindexModal + 100;